import { owaDate } from 'owa-datetime';
import type { WhatsNewCardState } from '../types/WhatsNewCardState';

export const hasCardExpired = (card: WhatsNewCardState | undefined): boolean => {
    return !!card?.expirationDate && card.expirationDate <= owaDate();
};
